import React from 'react';
import PropTypes from 'prop-types';

import envConfig from '../../constants/env';
import { withLang, getTranslationWithLocale, langType } from '../../i18n';

import styles from './accessibilityStatement.module.css';
import useTitle from '../../hooks/useTitle';

const AccessibilityError = ({ label, errorList }) => (
  <div className={styles.accessibilityError}>
    <h3>{label}</h3>
    <ul>
      {errorList.map((errorDescription) => (
        <li
          className={styles.accessibilityErrorDescription}
          key={errorDescription}
        >
          {errorDescription}
        </li>
      ))}
    </ul>
  </div>
);

const AccessibilityStatement = ({ translate, lang }) => {
  useTitle(translate('accessibilityStatement.mainTitle'));
  const getAccessibilityErrorList = () => {
    const accessibilityErrors = getTranslationWithLocale(
      'accessibilityStatement.listOfAccessibilityErrors',
      lang
    );
    return accessibilityErrors.map((accessibilityError) => (
      <AccessibilityError
        key={accessibilityError.heading}
        label={accessibilityError.heading}
        errorList={accessibilityError.descriptionList}
      />
    ));
  };
  const accessibilityFeedbackMailTo = `mailto: ${envConfig.ACCESSIBILITY_STATEMENT.feedbackAndContactEmail}`;

  return (
    <div className={styles.container}>
      <header>
        <h1 className={styles.title}>
          {translate('accessibilityStatement.mainTitle')}
        </h1>
      </header>
      <div className={styles.content}>
        <p>{translate('accessibilityStatement.generalInfo')}</p>
        <h2>
          {translate('accessibilityStatement.accessibilityStatementHeading')}
        </h2>
        <p>
          {translate('accessibilityStatement.accessibilityStatementContent')}
        </p>
        <h2>
          {translate('accessibilityStatement.nonAccessibleContentHeading')}
        </h2>
        <p>{translate('accessibilityStatement.nonAccessibilityGeneralInfo')}</p>
        {getAccessibilityErrorList()}
        <h2>{translate('accessibilityStatement.contactInformationHeading')}</h2>
        <p>{translate('accessibilityStatement.contactInformationContent')} <a href={accessibilityFeedbackMailTo}>{envConfig.ACCESSIBILITY_STATEMENT.feedbackAndContactEmail}</a></p>
        <h2>{translate('accessibilityStatement.governingAgencyHeading')}</h2>
        <p>{translate('accessibilityStatement.governingAgencyContent')}</p>
        <h2>
          {translate('accessibilityStatement.governingAgencyContactHeading')}
        </h2>
        <p className={styles.contactInfo}>
          {translate('accessibilityStatement.governingAgencyName')}
        </p>
        <p className={styles.contactInfo}>
          {translate('accessibilityStatement.governingAgencyUrl')}
        </p>
        <p className={styles.contactInfo}>
          {translate('accessibilityStatement.governingAgencyEmail')}
        </p>
        <p className={styles.contactInfo}>
          {translate('accessibilityStatement.governingAgencyPhoneDescription')}
        </p>
        <p className={styles.contactInfo}>
          {translate('accessibilityStatement.governingAgencyPhoneNumber')}
        </p>
      </div>
    </div>
  );
};

AccessibilityStatement.propTypes = langType;

AccessibilityError.propTypes = {
  label: PropTypes.string.isRequired,
  errorList: PropTypes.string.isRequired
};

export default withLang(AccessibilityStatement);
